import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { initAuth } from "./lib/auth";
import "./styles/globals.css";

// Single QueryClient — staleTime tuned for ops dashboard:
// most lists are cheap-to-refetch but we don't want re-renders on tab focus
// to flicker the densely packed tables.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: unknown) => {
        // Don't retry 401/403 — surface them so the auth guard can react.
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root");

// Bootstrap config + Supabase client BEFORE rendering. Once initAuth resolves
// the synchronous getSupabase() works for all the call sites that expect it.
initAuth()
  .catch((err) => console.error("[boot] initAuth failed", err))
  .finally(() => {
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={import.meta.env.DEV ? "/" : "/admin"}>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </React.StrictMode>,
    );
  });
